import { Button, Menu, Image, message, Space, Table } from "antd";
import { FrownOutlined } from "@ant-design/icons";
import Title from "antd/lib/typography/Title";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FormTextField from "../../components/general/FormTextField";
import { postImageRequest, postRequest } from "../../services/mainApp.service";
import { Popconfirm, Slider } from "antd";

const WebOrdering = () => {
  const [tableData, setTableData] = useState([]);
  const [settingsList, setSettingList] = useState([]);
  const uniqueParentNames = [...new Set(settingsList.map((item) => item.ParentName))];
  const [activeTab, setActiveTab] = useState(uniqueParentNames.length > 0 ? uniqueParentNames[0] : "");
  const userData = useSelector((state) => state.authReducer);
  const [testFontSize, setTestFontSize] = useState("");
  const [settingsObj, setSettingsObj] = useState({
    SettingId: null,
    File: null,
    Value: "",
    fontSize: "",
  });

  // console.log("checking settingsObj", settingsObj);

  const combineData = (settingsList, tableData) => {
    return settingsList.map((setting) => {
      const correspondingData = tableData.find(
        (data) => data.SetupDetailId === setting.SetupDetailId
      );

      return {
        ...setting,
        SettingId: correspondingData?.SettingId,
        SettingValue: correspondingData?.SettingValue,
      };
    });
  };

  const combinedData = combineData(settingsList, tableData);
  const banners = tableData.filter(
    (detail) => detail.SetupDetailName === "Upload Banner"
  );

  const onColorChange = (key, newValue) => {
    setTableData((prevData) =>
      prevData.map((row) =>
        row.SetupDetailId === key ? { ...row, SettingValue: newValue } : row
      )
    );
    setSettingList((prevData) =>
      prevData.map((row) =>
        row.SetupDetailId === key ? { ...row, SettingValue: newValue } : row
      )
    );
  };

  const columns = [
    {
      title: "File",
      key: "FileName",
      render: (_, record) =>
        record.Flex2 === "IMG" || record.Flex2 === "MULTIPLE_IMG" ? (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {record.Flex2 !== "MULTIPLE_IMG" && (
              <>
                {record.SettingValue ? (
                  <Image
                    src={
                      process.env.REACT_APP_BASEURL + "/" + record.SettingValue
                    }
                    style={{ width: "50px", height: "50px" }}
                  />
                ) : (
                  <div style={{ padding: "5px", textAlign: "center" }}>
                    <FrownOutlined
                      style={{ fontSize: "48px", color: "black" }}
                    />
                    <p>No Image</p>
                  </div>
                )}
              </>
            )}
            <input
              type="file"
              title="Upload Image"
              name="File"
              style={{ marginTop: "10px" }}
              onChange={(e) => handleImageChange(e, record)}
            />
          </div>
        ) : record.Flex2 === "COLOR" ? (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {record.SettingValue ? (
              <div
                style={{
                  height: 40,
                  width: 40,
                  backgroundColor: record.SettingValue,
                  border: `1px solid ${record.SettingValue}`,
                  borderRadius: "50%",
                }}
              ></div>
            ) : (
              <div style={{ padding: "5px", textAlign: "center" }}>
                <FrownOutlined style={{ fontSize: "48px", color: "black" }} />
                <p>No Color</p>
              </div>
            )}
          </div>
        ) : record.Flex2 === "FONT_SIZE" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxSizing: 'border-box'
            }}
          >

            <Slider
              min={8}
              max={72}
              name="fontsize"
              defaultValue={
                record.SettingValue ? Number(record.SettingValue) : 16
              }
              onChange={(value) => {
                handleFontSizeChange(value, record);
                setTestFontSize(value);
              }}
              style={{ width: "100%" }}
            />
          </div>
        ) : (
          <>
            <p style={{}}>{record.SettingValue}</p>
            <FormTextField
              colSpan={16}
              placeholder="Enter top bar text"
              name="Value"
              value={settingsObj.Value}
              onChange={(e) => handleTextChange(e, record)}
            />
          </>
        ),
    },

    {
      title: "Type",
      dataIndex: "SetupDetailName",
      key: "SetupDetailName",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {/* Show color input only if Flex2 is not TEXT, IMG, MULTIPLE_IMG, FONT_SIZE, or FONT_STYLE */}
          {record.Flex2 !== "TEXT" &&
            record.Flex2 !== "IMG" &&
            record.Flex2 !== "MULTIPLE_IMG" &&
            record.Flex2 !== "FONT_SIZE" &&
            record.Flex2 !== "FONT_STYLE" && (
              <input
                type="color"
                name="Value"
                value={setSettingsObj.Value}
                onChange={(e) => handleColorChange(e, record)}
                style={{ padding: "none" }}
              />
            )}

          <Button
            type="primary"
            style={{
              marginTop: "auto",
              borderRadius: "5px",
              backgroundColor: "#017971",
            }}
            onClick={(e) => {
              if (record.Flex2 === "COLOR") {
                updateColor(record);
              } else if (
                record.Flex2 === "IMG" ||
                record.Flex2 === "MULTIPLE_IMG"
              ) {
                updateImage(record);
              } else if (record.Flex2 === "TEXT") {
                updateText(record);
              } else if (record.Flex2 === "FONT_SIZE") {
                updateFontSize(record);
              } else if (record.Flex2 === "FONT_STYLE") {
                updateText(record);
              }
              // Add handling for FONT_SIZE and FONT_STYLE if needed
            }}
          >
            {(() => {
              switch (record.Flex2) {
                case "COLOR":
                  return "Update";
                case "IMG":
                  return "Update Logo";
                case "TEXT":
                  return "Update Text";
                case "MULTIPLE_IMG":
                  return "Update Banner";
                case "FONT_SIZE":
                  return "Update Font Size";
                case "FONT_STYLE":
                  return "Update Font Style"; // Add a specific case for FONT_STYLE
                default:
                  return "";
              }
            })()}
          </Button>
        </Space>
      ),
    },
  ];

  const controller = new window.AbortController();

  useEffect(() => {
    if (!activeTab && uniqueParentNames.length > 0) {
      setActiveTab(uniqueParentNames[0]);
    }
    const formData = new FormData();
    formData.append("OperationId", 1);
    formData.append("CompanyId", userData.CompanyId);
    formData.append("UserId", userData.UserId);
    formData.append("SettingId", null);
    formData.append("Value", "");
    formData.append("UserIP", "12.1.1.12");
    formData.append("SetupDetailId", null);
    postImageRequest("/WebOrderingSetting", formData, controller).then(
      (response) => {
        if (response.error === true) {
          message.error(response.errorMessage);
          return;
        }
        if (response.data.response === false) {
          message.error(response.DataSet.Table.errorMessage);
          return;
        }
        setSettingList(response.data.DataSet.Table);
        setTableData(response.data.DataSet.Table1);
      }
    );

    return () => {
      controller.abort();
    };
  }, [activeTab]);

  const handleTextChange = (e, record) => {
    // // console.log('woow', e)
    setSettingsObj({
      ...settingsObj,
      [e.name]: e.value,
      SettingId: record.SetupDetailId,
    });
    // console.log("checking settingsObj after text change", settingsObj);
  };

  const handleImageChange = (e, record) => {
    setSettingsObj({
      ...settingsObj,
      [e.target.name]: e.target.files[0],
      SettingId: record.SetupDetailId,
    });
  };

  const handleColorChange = (e, record) => {
    setSettingsObj({
      ...settingsObj,
      Value: e.target.value,
      SettingId: record.SetupDetailId,
    });
  };

  const handleFontSizeChange = (value, record) => {
    setSettingsObj({
      ...settingsObj,
      fontSize: value,
      SettingId: record.SetupDetailId,
    });
    // console.log("checking settingsObj after text change", settingsObj);
  };

  const updateFontSize = (record) => {
    if (settingsObj.SettingId === null || settingsObj.fontsize === null) {
      message.error("Provide Correct Inputs");
    } else {
      const formData = new FormData();
      formData.append("OperationId", 2);
      formData.append("CompanyId", userData.CompanyId);
      formData.append("UserId", userData.UserId);
      formData.append("SettingId", settingsObj.SettingId);
      formData.append("Value", settingsObj.fontSize);
      formData.append("UserIP", "12.1.1.12");
      formData.append("SetupDetailId", settingsObj.SettingId);
      // console.log("this is your fomData", formData);
      postImageRequest("/WebOrderingSetting", formData, controller).then(
        (response) => {
          if (response.error === true) {
            message.error(response.errorMessage);
            return;
          }
          if (response.data.response === false) {
            message.error(response.DataSet.Table.Error_Message);
            return;
          }
          if (response.data.Response === true) {
            setTableData(response.data.DataSet.Table2);
          }
          message.success("Uploaded Successfully");
        }
      );
      setSettingsObj({
        SettingId: null,
        File: null,
        Value: "",
        fontsize: "",
      });
    }
  };

  const updateText = (record) => {
    if (settingsObj.SettingId === null || settingsObj.Value === null) {
      message.error("Provide Correct Inputs");
    } else {
      const formData = new FormData();
      formData.append("OperationId", 2);
      formData.append("CompanyId", userData.CompanyId);
      formData.append("UserId", userData.UserId);
      formData.append("SettingId", settingsObj.SettingId);
      formData.append("Value", settingsObj.Value);
      formData.append("UserIP", "12.1.1.12");
      formData.append("SetupDetailId", settingsObj.SettingId);
      // console.log("this is your fomData", formData);
      postImageRequest("/WebOrderingSetting", formData, controller).then(
        (response) => {
          if (response.error === true) {
            message.error(response.errorMessage);
            return;
          }
          if (response.data.response === false) {
            message.error(response.DataSet.Table.Error_Message);
            return;
          }
          if (response.data.Response === true) {
            setTableData(response.data.DataSet.Table2);
          }
          message.success("Uploaded Successfully");
        }
      );
      setSettingsObj({
        SettingId: null,
        File: null,
        Value: "",
      });
    }
  };

  const updateImage = (record) => {
    if (settingsObj.SettingId === null || settingsObj.File === null) {
      message.error("Provide Correct Inputs");
    } else {
      const formData = new FormData();
      formData.append("OperationId", 2);
      formData.append("CompanyId", userData.CompanyId);
      formData.append("UserId", userData.UserId);
      formData.append("SettingId", settingsObj.SettingId);
      formData.append("Value", settingsObj.File);
      formData.append("UserIP", "12.1.1.12");
      formData.append("SetupDetailId", settingsObj.SettingId);

      postImageRequest("/WebOrderingSetting", formData, controller).then(
        (response) => {
          if (response.error === true) {
            message.error(response.errorMessage);
            return;
          }
          if (response.data.response === false) {
            message.error(response.DataSet.Table.Error_Message);
            return;
          }
          if (response.data.Response === true) {
            setTableData(response.data.DataSet.Table2);
          }
          message.success("Uploaded Successfully");
        }
      );
      setSettingsObj({
        SettingId: null,
        File: null,
        Value: "",
      });
    }
  };

  const updateColor = (e) => {
    if (settingsObj.SettingId === null || settingsObj.Value === "") {
      message.error("Provide Correct Inputs");
    } else {
      const formData = new FormData();
      formData.append("OperationId", 3);
      formData.append("CompanyId", userData.CompanyId);
      formData.append("UserId", userData.UserId);
      formData.append("SettingId", settingsObj.SettingId);
      formData.append("Value", settingsObj.Value);
      formData.append("UserIP", "12.1.1.12");
      formData.append("SetupDetailId", settingsObj.SettingId);
      postImageRequest("/WebOrderingSetting", formData, controller).then(
        (response) => {
          if (response.error === true) {
            message.error(response.errorMessage);
            return;
          }
          if (response.data.response === false) {
            message.error(response.DataSet.Table.Error_Message);
            return;
          }
          if (response.data.Response === true) {
            setTableData(response.data.DataSet.Table2);
          }
          message.success("Added Successfully");
        }
      );
      setSettingsObj({
        SettingId: null,
        File: null,
        Value: "",
      });
    }
  };

  const handleDelete = (banner) => {
    const formData = new FormData();
    formData.append("OperationId", 4);
    formData.append("CompanyId", userData.CompanyId);
    formData.append("UserId", userData.UserId);
    formData.append("SettingId", banner.SettingId);
    formData.append("Value", null);
    formData.append("UserIP", "12.1.1.12");
    formData.append("SetupDetailId", banner.SettingId);

    postImageRequest("/WebOrderingSetting", formData, controller).then(
      (response) => {
        if (response.error === true) {
          message.error(response.errorMessage);
          return;
        }
        if (response.data.response === false) {
          message.error(response.DataSet.Table.Error_Message);
          return;
        }
        if (response.data.Response === true) {
          setTableData(response.data.DataSet.Table2);
        }
        message.success("Deleted Successfully");
      }
    );
  };
  const menuItemStyle = {
    padding: "0px 10px",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "8px",
    margin: "-2px 8px",
    transition: "all 0.3s ease-in-out",
  };

  const activeStyle = {
    backgroundColor: "#E8EEF0",
    color: "black",
  };

  const hoverStyle = {
    backgroundColor: "white",
  };

  return (
    <>
      <Title level={3} style={{ color: "#017971" }}>
        Web Ordering Settings
      </Title>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Menu
          mode="horizontal"
          selectedKeys={[activeTab]}
          onClick={({ key }) => setActiveTab(key)}
          style={{
            borderBottom: "none",
            display: "inline-block",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingBottom: "5px",
            paddingTop: "2px",
            justifyContent: "center",
            // border: "1px solid #017971",
            // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "40px",
          }}
        >
          {uniqueParentNames.map((name) => (
            <Menu.Item
              key={name}
              style={{
                ...menuItemStyle,
                ...(activeTab === name ? activeStyle : {}),
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  hoverStyle.backgroundColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  activeTab === name
                    ? activeStyle.backgroundColor
                    : "transparent";
              }}
            >
              {name}
            </Menu.Item>
          ))}
        </Menu>
      </div>


      <Table
        columns={columns}
        dataSource={combinedData.filter(
          (item) => item.ParentName === activeTab
        )}
        rowKey="SetupDetailId"
      />
      {activeTab === "Banner" && (
        <div>
          {banners.map((banner) => (
            <div
              key={banner.SettingId}
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <img
                src={process.env.REACT_APP_BASEURL + "/" + banner.SettingValue}
                alt="Banner"
                style={{
                  width: "160px",
                  borderRadius: "10px",
                  height: "80px",
                  marginRight: "10px",
                }}
              />
              <Popconfirm
                title="Are you sure to delete this banner?"
                onConfirm={() => handleDelete(banner)}
                okText="Yes"
                cancelText="No"
              >
                <button
                  style={{
                    padding: "8px 23px",
                    backgroundColor: "red",
                    cursor: "pointer",
                    borderRadius: "5px",
                    color: "white",
                    border: "none",
                  }}
                >
                  Delete
                </button>
              </Popconfirm>
            </div>
          ))}
        </div>
      )}
      <p
        style={{
          fontSize: testFontSize,
          width: "100%",
          whiteSpace: "normal", // Allow text to wrap
          overflow: "hidden", // Prevent overflow
          textOverflow: "ellipsis", // Optional: Show ellipsis if text overflows
        }}
      >
        Test for checking font size.
      </p>
    </>
  );
};

export default WebOrdering;
